import React, { useState } from "react";
import "./ForgotPassword.scss";
import Logo from "../../assets/Logo.png";
import Logo_Banner from "../../assets/logo_banner.png";
import { useNavigate } from "react-router-dom";
import Eye_View from "../../assets/eye_view.png";
import Eye_Hide from "../../assets/eye_hide.png";
import { useForm } from "react-hook-form";
import { webEndPoint } from "../../constant/constant";
import { makeRequest } from "../../services/api";
import Loader from "../../components/Loader/Loader";
import { getItem, setItem } from "../../services/utilities";
import AlertModal from "./../../components/Modals/AlertModal";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function CreateNewPassword() {
  let navigate = useNavigate();
  let userOtpNo = "";
  let userOtpData = "";
  let userData = [];
  try {
    userOtpNo = getItem("userOtpNol");
    userOtpData = getItem("userOtpDetail");
    userData = getItem("userDetail");
  } catch (err) {}

  const [errorMsg, setErrorMsg] = useState("");
  const [show, setShow] = useState(false);
  const [shows, setShows] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const password_toggle = () => {
    setShow(!show);
  };
  const password_toggles = () => {
    setShows(!shows);
  };
  const onSubmit = (data) => {
    if (data.newpassword === data.confirmpassword) {
      setItem("userOtpNol", data.code);
      sentOtp({
        verification_type: "forgot_password",
        otp_id: userOtpData?.data?.otp_id,
        user_otp: userOtpNo,
        user_id: userData?.data?.userId,
        new_password: data.newpassword,
      });
    } else {
      setErrorMsg('New and Confirm Password Mismatch');
      setOpenModal(true);
    }
  };
  const sentOtp = async (data) => {
    try {
      setLoading(true);
      let url = webEndPoint + "auth/change-password-with-otp";
      const response = await makeRequest("post", url, data);
      if (response) {
        setLoading(false);
        if (response.message === "Success") {
          setLoading(false);
          navigate("/password-reset");
        } else if (response.message === "Fail") {
          setLoading(false);
          setErrorMsg(JSON.stringify(response.alert) || 'Password reset failed');
          setOpenModal(true);
        }
      }
    } catch (err) {
      setLoading(false);
      setErrorMsg(JSON.stringify(err.alert) || 'Password reset failed');
      setOpenModal(true);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Loader loading={loading} />
      <div className="grid">
        <div className="order__left centered">
          <div className="form">
            <img
              className="astro_logo centered"
              src={Logo}
              alt="astrocure_logo"
            />
            <p className="forgot-password-header-text">
              Choose your new password
            </p>
            <p className="forgot-description-text">
              Choose a new password to keep your account safe and secure.
            </p>
            <div className="fullname-input-container-sign">
              <label className="fullname-label">
                Choose a new password{" "}
                <span className="fullname-required">*</span>
              </label>
              <input
                {...register("newpassword", { required: true })}
                type={show ? "text" : "password"}
                id="newpassword"
                name="newpassword"
                placeholder="Enter New password"
                className="forgot_input_style"
                autoComplete="off"
              />

              <span
                className="password_icon_view"
                onClick={password_toggle}
                aria-label={show ? "Hide password" : "Show password"}
                role="button"
              >
                {show ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
            {errors.newpassword && (
              <p className="alert_msg">New password is required.</p>
            )}
            <div className="fullname-input-container-sign">
              <label className="fullname-label">
                Confirm password <span className="fullname-required">*</span>
              </label>
              <input
                {...register("confirmpassword", { required: true })}
                type={shows ? "text" : "password"}
                id="confirmpassword"
                name="confirmpassword"
                className="forgot_input_style"
                placeholder="Confirm Password"
                autocomplete="off"
              />
              <span
                className="password_icon_view"
                onClick={password_toggles}
                aria-label={shows ? "Hide password" : "Show password"}
                role="button"
              >
                {shows ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
            {errors.newpassword && (
              <p className="alert_msg">Confirm Password is required.</p>
            )}
            <p className="pwd-description-text">
              Must be at least 8 characters.
            </p>
            <div className="fullname-input-container-sign">
              <button type="submit" class="verify_code verify-text">
                Reset Password
              </button>
            </div>
            <div class="signup">
              <label className="remember_me">Copyright © 2024</label>
              <a href="#" class="forgot__password">
                <strong>Astrovidhi Private Limited</strong>{" "}
              </a>{" "}
              <label className="remember_me"> All rights reserved</label>
            </div>
          </div>
        </div>
        <div className="order__right no__overflow banner">
          <img className="banner__image" src={Logo_Banner} alt="banner" />
        </div>
      </div>
      <AlertModal open={openModal} setOpen={setOpenModal} errorMsg={errorMsg} />
    </form>
  );
}

export default CreateNewPassword;
